import { isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import * as Sentry from '@sentry/angular';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// Инициализируем Sentry только в production режиме
if (!isDevMode()) {
  Sentry.init({
  dsn: 'https://cbcbd7df13e7c0003888bd09b4a63831@sentry.gogologins.com/15',
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Отключаем распространение заголовков трассировки для нашего API
  // Пустой массив означает, что заголовки трассировки не будут добавляться к запросам
  tracePropagationTargets: [], // Отключено для предотвращения CORS ошибок с заголовком baggage
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  // eslint-disable-next-line no-console
  console.error(err),
);
